import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    templateUrl: './not-authorized.component.html',
    styleUrls: ['./not-authorized.component.css'],
    standalone: false
})
export class NotAuthorizedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
